import * as React from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import { GFUser } from '../../models/models';

interface Props {
  user: GFUser;
}

export const StudentCountBanner = (props: Props) => {
  const numberStyle: React.CSSProperties = { fontSize: `1.5em` };
  const { user } = props;
  const totalStudents = user.maxStudents - user.availableStudents;

  return (
    <Row className="verification-header" style={{ paddingTop: 10 }}>
      <Col xs={12}>
        <Alert bsStyle="info" className='flex-banner-alert'>
          <div>
            <span style={{ paddingLeft: '20px' }}>Total Purchased Student Seats: </span>
            <span style={numberStyle}>{user.maxStudents}</span>
            <span style={{ paddingLeft: '20px' }}>Filled Student Seats: </span>
            <span style={numberStyle}>{totalStudents}</span>
            <span style={{ paddingLeft: '20px' }}>Available Student Seats: </span>
            <span style={numberStyle}>{user.availableStudents}</span>
          </div>
        </Alert>
      </Col>
    </Row>
  );
};
